import { render, staticRenderFns } from "./ContactDrawer.vue?vue&type=template&id=f5d0b216&scoped=true&"
import script from "./ContactDrawer.vue?vue&type=script&lang=ts&"
export * from "./ContactDrawer.vue?vue&type=script&lang=ts&"
import style0 from "./ContactDrawer.vue?vue&type=style&index=0&id=f5d0b216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d0b216",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VNavigationDrawer } from 'vuetify/lib/components/VNavigationDrawer';
installComponents(component, {VBtn,VIcon,VImg,VNavigationDrawer})
